import maps from './maps';
import time from './time';
import icons from './icons';
import theme from './theme';
import toolbar from './toolbar';
import locales from './locales';
import analytics from './analytics';
import currencies from './currencies';
import navigation from './navigation';
export default {
  // product display information
  product: {
    name: 'INCA',
    version: '2.0.0-beta'
  },
  // google maps
  maps: maps,
  // time configs
  time: time,
  // icon libraries
  icons: icons,
  // theme configs
  theme: theme,
  // toolbar configs
  toolbar: toolbar,
  // locales configs
  locales: locales,
  // analytics configs
  analytics: analytics,
  // currencies configs
  currencies: currencies,
  // navigation configs
  navigation: navigation
};